// extracted by mini-css-extract-plugin
module.exports = {"whatsapp-button":"default_whatsapp-button__rURI2","wave-animation":"default_wave-animation__2eZov","icon":"default_icon__bZkfD"};